import React from 'react';
import { Card, Grid } from 'ui-toolkit';
import { ITitleSearchComponentProps, TitleSearchComponent } from '../../../components/order/title/TitleSearchComponent';
import {
  IPayoffRequestComponentComponentProps,
  PayoffRequestComponent,
} from '../../../components/order/title/PayoffRequestComponent';
import {
  ITaxCertificationRequestComponentProps,
  TaxCertificationRequestContainer,
} from '../taxCertifications/TaxCertificationRequestContainer';

interface ITitleTitleSearchPageProps
  extends ITitleSearchComponentProps,
    IPayoffRequestComponentComponentProps,
    ITaxCertificationRequestComponentProps {}

export const TitleSearchPage: React.FC<ITitleTitleSearchPageProps> = ({
  titleSearchRequests,
  titleSearchRequestFetchStatus,
  onCreateNewTitleSearch,
  onCancelTitleSearch,
  orderId,
  renderTitleIssuedAgentButton,
  redVisionSearch,
  onCancelFetchStatus,
  onCreateFetchStatus,
  onCreateError,
  onCancelError,
  payoffs,
  onCancelPayoff,
  onCreatePayoff,
  cancelPayoffError,
  createPayoffError,
  cancelFetchStatus,
  createFetchStatus,
  taxCertificationRequest,
  onCreateTaxCertification,
  onCancelTaxCertification,
  createTaxCertFetchStatus,
  cancelTaxCertFetchStatus,
  cancelTaxCertificationError,
  createTaxCertificationRequestError,
}) => {
  return (
    <Card title={'Title Search and Vendor Services'}>
      <Grid>
        <TitleSearchComponent
          titleSearchRequests={titleSearchRequests}
          titleSearchRequestFetchStatus={titleSearchRequestFetchStatus}
          orderId={orderId}
          renderTitleIssuedAgentButton={renderTitleIssuedAgentButton}
          onCreateNewTitleSearch={onCreateNewTitleSearch}
          onCancelTitleSearch={onCancelTitleSearch}
          onCancelFetchStatus={onCancelFetchStatus}
          onCreateFetchStatus={onCreateFetchStatus}
          onCreateError={onCreateError}
          onCancelError={onCancelError}
          redVisionSearch={redVisionSearch}
        />
        <PayoffRequestComponent
          payoffs={payoffs}
          onCancelPayoff={onCancelPayoff}
          onCreatePayoff={onCreatePayoff}
          cancelFetchStatus={cancelFetchStatus}
          cancelPayoffError={cancelPayoffError}
          createFetchStatus={createFetchStatus}
          createPayoffError={createPayoffError}
        />
        <TaxCertificationRequestContainer
          orderId={orderId}
          taxCertificationRequest={taxCertificationRequest}
          onCreateTaxCertification={onCreateTaxCertification}
          onCancelTaxCertification={onCancelTaxCertification}
          createTaxCertFetchStatus={createTaxCertFetchStatus}
          cancelTaxCertFetchStatus={cancelTaxCertFetchStatus}
          cancelTaxCertificationError={cancelTaxCertificationError}
          createTaxCertificationRequestError={createTaxCertificationRequestError}
        />
      </Grid>
    </Card>
  );
};
